import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-declined',
    templateUrl: './declined.component.html',
    styleUrls: ['./declined.component.css']
})
export class DeclinedComponent implements OnInit {
    customerName = '';

    constructor(private router: Router) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.customerName = navigation.extras.state.customerName;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit(): void {
        void (0);
    }

    onBackClick() {
        this.router.navigateByUrl('/');
    }
}
